export default "__VITE_ASSET__CG3WQ4xx__"